/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Classification_Agent_CompatibleInputs */

const en_directory_agent_readiness_classification_agent_compatible = /** @type {(inputs: Directory_Agent_Readiness_Classification_Agent_CompatibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent compatible`)
};

const zh_directory_agent_readiness_classification_agent_compatible = /** @type {(inputs: Directory_Agent_Readiness_Classification_Agent_CompatibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 兼容`)
};

/**
* | output |
* | --- |
* | "Agent compatible" |
*
* @param {Directory_Agent_Readiness_Classification_Agent_CompatibleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_classification_agent_compatible = /** @type {((inputs?: Directory_Agent_Readiness_Classification_Agent_CompatibleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Classification_Agent_CompatibleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_classification_agent_compatible(inputs)
	return zh_directory_agent_readiness_classification_agent_compatible(inputs)
});
export { directory_agent_readiness_classification_agent_compatible as "directory.agent_readiness.classification.agent_compatible" }